import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { LoginComponent } from "../auth/pages/login/login.component";
import { AuthGuardService } from "../auth/services/auth.guard.service";
import { HomeComponent } from "../shared/pages/home/home.component";
import { RelatorioPagamentoDecendialComponent } from "../spg/pages/relatorio-pagamento-decendial/relatorio-pagamento-decendial.component";
import { LostPasswordComponent } from "../auth/pages/lost-password/lost-password.component";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "lost-password", component: LostPasswordComponent },
  { path: "home", component: HomeComponent, canActivate: [AuthGuardService] },
  {
    path: "spg/relatorio-pagamento-decendial",
    component: RelatorioPagamentoDecendialComponent,
    canActivate: [AuthGuardService],
  },
  { path: "**", redirectTo: "login", pathMatch: "prefix" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
